import { markSkipOnCompleteIfOnSuccessIsSet, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddLinesToCart";

replaceInChain(chain, ExecuteOnSuccessCallback, props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    (props.parameter.onSuccess as any)?.(props.apiResult); // Poolcorp Custom Code
});
